import { LitElement, html, Splide } from '@hh/global.js'

class SectionHorizontalScrollCarousel extends LitElement {
  constructor() {
    super()

    this.imageSlider = null
    this.childSliders = []
  }

  connectedCallback() {
    super.connectedCallback()

    this.desktopHeadings = this.querySelectorAll('[data-desktop-heading]')
    this.desktopDetails = this.querySelectorAll('[data-desktop-detail]')
    this.headingButtons = this.querySelectorAll('[data-heading-toggle]')

    const sliderHolders = this.querySelectorAll('[data-slider-holder]')
    sliderHolders.forEach(sliderHolder => this.initSlider(sliderHolder))

    this.slideEvents()

    this.childSliders.forEach(slider => {
      this.imageSlider?.sync(slider)
      slider.mount()
    })
    this.imageSlider?.mount()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.headingButtons?.forEach(headingButton => {
      headingButton.removeEventListener('click', () => headingInteraction(headingButton))
      headingButton.removeEventListener('mouseenter', () => headingInteraction(headingButton))
    })
  }

  slideEvents() {
    this.imageSlider?.on( 'move', () => {
      this.desktopHeadings.forEach((heading, index) => {
        heading.classList.toggle('active', this.imageSlider.index === index)
      })

      this.desktopDetails.forEach((detail, index) => {
        detail.classList.toggle('active', this.imageSlider.index === index)
      })
    })

    const headingInteraction = (headingButton) => {
      const activeIndex = Number(headingButton?.dataset?.slideIndex ?? 0)
      this.imageSlider?.go(activeIndex)
    }

    this.headingButtons.forEach(headingButton => {
      headingButton.addEventListener('click', () => headingInteraction(headingButton))
      headingButton.addEventListener('mouseenter', () => headingInteraction(headingButton))
    })
  }

  initSlider(sliderHolder) {
    const slider = new Splide(sliderHolder, {
      type: 'slide',
      arrows: false,
      pagination: true,
      autoplay: false,
      pauseOnHover: false,
      perPage: 1,
      trimSpace: false,
      drag: true,
      direction: 'ltr',
      speed: 1000
    })

    if (sliderHolder.hasAttribute('data-image-slider')) {
      this.imageSlider = slider
    } else {
      this.childSliders.push(slider)
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('horizontal-scroll-carousel', SectionHorizontalScrollCarousel)
